// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  palette: { greyscale, noodle },
} = getTheme();
const ProgramCardWrapper: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .program-card {
    &__description {
      color: ${greyscale.mineShaft};
      font-size: 1.4rem;
      line-height: 2rem;
      margin-bottom: 0.8rem;
    }

    &__image-container {
      margin-bottom: 0.8rem;
      position: relative;
    }

    &__image {
      cursor: pointer;
      max-height: 22.7rem;
      min-height: 22.7rem;
      object-fit: cover;
      width: 100%;
      border-radius: 0.4rem;
    }

    &__logo {
      bottom: 0.8rem;
      border-radius: 50%;
      height: 4.8rem;
      left: 0.8rem;
      object-fit: cover;
      position: absolute;
      width: 4.8rem;
    }

    &__request-info {
      cursor: pointer;
      font-size: 1.6rem;
      line-height: 1.9rem;
      text-decoration: underline;
      font-size: 1.5rem;
      font-weight: 600;
      user-select: none;
      display: flex;
      flex: 1;
      align-items: flex-end;
    }

    &__title {
      color: ${greyscale.mirage};
      font-size: 2.4rem;
      margin-bottom: 1.2rem;
      margin-top: 1.2rem;
      font-weight: 600;
      font-family: Inter, sans-serif;
    }

    &__subtitle {
      color: ${greyscale.mirage};
      font-size: 1.6rem;
      font-weight: 600;
    }

    &__subtitle2 {
      color: ${greyscale.mirage};
      margin-bottom: 2.4rem;
      font-size: 1.5rem;
    }

    &__read-more {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .request-info-overlay {
    align-items: center;
    background-color: rgba(227, 234, 239, 0.5);
    border-radius: 0.4rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 1.3rem;
    padding-left: 1.6rem;
    padding-right: 1.6rem;
    padding-top: 3.2rem;
    position: absolute;
    width: 100%;
    z-index: 1;

    &__cancel-btn {
      color: ${greyscale.outerSpace};
      cursor: pointer;
      font-size: 1.6rem;
      line-height: 1.9rem;
      margin-top: auto;
    }

    &__program-page-btn,
    &__request-info-btn {
      align-items: center;
      align-self: center;
      border-radius: 0.4rem;
      cursor: pointer;
      display: flex;
      font-size: 1.6rem;
      height: 4.8rem;
      justify-content: center;
      line-height: 1.9rem;
      max-width: 100%;
      transition: all 0.3s;
      width: 22.4rem;
    }

    &__program-page-btn {
      background-color: ${greyscale.white};
      border: 1px solid ${noodle.primary};

      &:hover {
        background-color: ${greyscale.whiteHover};
        color: ${noodle.primary};
      }
    }

    &__request-info-btn {
      background-color: ${noodle.primary};
      color: ${greyscale.white};
      margin-bottom: 1.6rem;

      &:hover {
        background-color: ${noodle.secondary};
      }
    }
  }
`;
export default ProgramCardWrapper;
